<template>
  <div class="main-container la-storia" v-if="this.pageData">

    <h2 class="title" v-if="lang === 'it'">
      <span>Benvenuti</span>
      <span>nell’antiquarium</span>
    </h2>

    <h2 class="title" v-if="lang === 'en'">
      <span>Welcome</span>
      <span>to the antiquarium</span>
    </h2>

    <h2 class="title" v-if="lang === 'de'">
      <span>Willkommen</span>
      <span>im Antiquarium</span>
    </h2>

    <SpallaVideo v-if="this.showSpalla" :spalladata="this.spallaComputedData" @close-spalla="toggleSpalla('close')" />
   
    <div class="main-content">
      <div class="container">
        <div :class="['video-container', 'storia', { videoPlaying: isPlaying }]" @click="playVideo()">
          <div class="controls">
            <img class="play" src="../assets/play-button.svg" width="600" height="400" alt="">
            <img class="pause" src="../assets/pause-button.svg" width="600" height="400" alt="">
          </div>
          <video ref="video" preload="none" @ended="onEnd()" poster="../assets/video/poster-placeholder-video.jpg"
            :src="videoUrl" type="video/webm">
          </video>
        </div>
        <button class="btn icon-right outline testo-video" @click="toggleSpalla">
          <span>{{ this.$store.state.labelData[this.lang].video_button }}</span>
        </button>
      </div>
    </div>

    <div class="container-inizia-visita">
      <div class="intro">
        <div class="img">
          <img src="@/assets/icon-inizia-guida.svg" alt="">
          <img class="filigrna" src="@/assets/filigrana-artefatto.png" alt="" />
        </div>
        <h2 class="title" v-if="lang === 'it'">
          <span>Inizia la tua</span>
          <span>visita guidata</span>
        </h2>
        <h2 class="title" v-if="lang === 'en'">
          <span>Start your</span>
          <span>guided visit</span>
        </h2>
        <h2 class="title" v-if="lang === 'de'">
          <span>Beginnen Sie Ihren</span>
          <span>geführten Rundgang</span>
        </h2>
        <p v-if="lang === 'it'">
          Inizia la tua visita seguendo i numeri esposti vicino ai reperti oppure ordina per datazione e scopri la loro
          storia.
        </p>
        <p v-if="lang === 'en'">
          Start your visit by following the numbers displayed next to the artefacts, or sort them by date and discover
          their history.
        </p>
        <p v-if="lang === 'de'">
          Beginnen Sie Ihren Rundgang, indem Sie den neben den Funden angebrachten Nummern folgen, oder sortieren Sie
          sie nach Datierung und entdecken Sie ihre Geschichte.
        </p>
      </div>
    </div>

    <div class="container-items alt-layout">
      <nav>
        <ul>
          <div v-if="lang === 'it'"><img src="@/assets/icon-sort.svg" alt="">Ordina per</div>
          <div v-if="lang === 'en'"><img src="@/assets/icon-sort.svg" alt="">Sort by</div>
          <div v-if="lang === 'de'"><img src="@/assets/icon-sort.svg" alt="">Sortieren nach</div>
          <li :class="[this.sortedBy == 'secolo' ? 'selected' : '']" @click="sortBy('secolo')">
            <span v-if="lang === 'it'">Secolo</span>
            <span v-if="lang === 'en'">Century</span>
            <span v-if="lang === 'de'">Jahrhundert</span>
          </li>
          <li :class="[this.sortedBy == 'numero' ? 'selected' : '']" @click="sortBy('numero')">
            <span v-if="lang === 'it'">Numero</span>
            <span v-if="lang === 'en'">Number</span>
            <span v-if="lang === 'de'">Nummer</span>
          </li>
        </ul>
      </nav>

      <div class="reperti" v-if="this.museumData">
        <div class="timeline">
          <div class="list">
            <item-tile v-for="(r, index) in this.museumData" :key="'reperto' + index" :routesdata="routesData"
              :itemdata="r"></item-tile>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  fetchRoutes,
  fetchNodes,
  fetchSinglePage,
  getTranslation
} from '../libs/drupalClient'

import SpallaVideo from '@/components/SpallaVideo'
import ItemTile from '@/components/ItemTile'


export default {
  name: 'la-storia',
  components: {
    SpallaVideo,
    ItemTile
  },
  data: () => {
    return {
      sortedBy: "secolo",
      isPlaying: false,
      pageData: null,
      showSpalla: false,
      currentPageID: "c111f013-0c30-4372-b82a-df5445f1f435",
      routesData: [],
      spallaData: {
        spallaTitle: "",
        spallaContent: {},
        spallaImages: "",
        spallaTexts: "",
        spallaCover: "",
        spallaTipo: ""
      },
    }
  },
  metaInfo() {
        return {
            title: this.objecttitle,
            meta: [{
                property: 'og:title',
                content: this.objecttitle
            }]
        }
    },
  computed: {
    objecttitle() {
      var t = this.lang === 'it' ? "La storia" :
              this.lang === 'en' ? "The history" :
              this.lang === 'de' ? "Die Geschichte"
              : "La storia";

      return t
    },
    museumData() {
      return this.$store.state.museumData
    },
    spallaComputedData() {
      return this.spallaData
    },
    lang() {
      return this.$store.state.currentLang
    },
    videoUrl() {
      if (this.pageData.field_pagina_base_video)
        return process.env.VUE_APP_ENDPOINT + this.pageData.field_pagina_base_video.attributes.uri.url
      else return ''
    },
  },
  methods: {
    sortBy(el) {
      
      console.log('sortBy',el);
      this.sortedBy = el
      this.$store.commit('SET_SORTED_BY',el)

      if(el == "numero") {
        this.$store.commit('SET_MUSEUMDATA',
          this.museumData.sort((a, b) => {
            return a.attributes.field_ordine_esposizione < b.attributes.field_ordine_esposizione ? -1 : 1
          })
        )
      } else {
        this.$store.commit('SET_MUSEUMDATA',
          this.museumData.sort((a, b) => {
            return a.attributes.field_ordinamento < b.attributes.field_ordinamento ? -1 : 1
          })
        )
      }
    },
    toggleSpalla() {
      this.spallaData.spallaTitle = this.pageData.attributes.title
      this.spallaData.spallaContent = this.pageData
      this.spallaData.spallaCover = ""
      this.spallaData.spallaTexts = "field_ref_ui_text"
      this.spallaData.spallaImages = "field_page_immagini"
      this.spallaData.spallaTipo = "Testo video"
      this.showSpalla = !this.showSpalla
    },
    play() {
      this.$refs.video.play()
    },
    pause() {
      this.$refs.video.pause()
    },
    onEnd() {
      this.isPlaying = false
    },
    playVideo() {
      if (!this.isPlaying) {
        this.play()
        this.isPlaying = true
      } else {
        this.isPlaying = false
        this.pause()
      }
    },
    changeVideo() {
      this.pause()
      this.isPlaying = false
      this.$refs.video.src = this.videoUrl
    },
    async findPageData() {
      await fetchSinglePage(this.currentPageID, this.lang)
        .then(res => {
          this.pageData = res
          //console.log('res',res);
        })

      await fetchNodes('reperto', {
        include: ['field_reperto_foto', 'field_reperto_video', 'field_ref_approfondimenti']
      }, this.lang).then(res => {
        this.$store.commit('SET_MUSEUMDATA',
          res.sort((a, b) => {
             return a.attributes.field_ordinamento < b.attributes.field_ordinamento ? -1 : 1
          })
        )
      })
    }
  },
  async mounted() {
    console.log('sortedBy',this.sortedBy);
    await fetchRoutes().then(r => this.routesData = r.routes)
    await this.findPageData()

    console.log('this.$store',this.$store.state.sorted_by);
    this.sortBy(this.$store.state.sorted_by)
  },
  watch: {
    lang() {
      getTranslation(this.$route.name, this.lang)
        .then(res => this.$router.push({ path: res }))

      this.findPageData()
      this.changeVideo()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.main-container {
  background-color: #181923;
}

.title {
  padding-top: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-transform: uppercase;
  margin: 0;
  padding-bottom: 1rem;
  font-size: 32px;

  span {
    color: #fff;
  }

  span:last-child {
    color: #C79641;
  }
}

.main-content {
  margin-top: 2rem;

  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .btn.outline {
      border: 1px solid #fff;
      color: #fff;
      width: 100%;
    }
  }
}

.container-inizia-visita {
  .intro {
    padding: 1rem 15px 0 15px;
    padding-bottom: 2rem;
  }

  .img {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 220px;
    margin-bottom: -60px;

    img {
      position: absolute;
      width: 104px;
      z-index: 1;
    }

    img.filigrna {
      width: 290px;
      z-index: 0;
      z-index: 0;
    }
  }

  .title {
    padding-top: 20px;
  }

  p {
    color: #fff;
    margin: 0;
    text-align: center;
    font-size: 18px;
    line-height: 28px;
  }
}

.container-items {
  nav {
    border-top: 1px solid #445068;
    border-bottom: 1px solid #445068;
  }
  ul {
    display: flex;
    flex-direction: row;

    >div,
    >li {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
    }

    li.selected {
      color: #C79641;
      border-bottom: 3px solid #C79641;
    }

    div {
      width: 40%;
      color: #CACACA;
      text-align: left;

      img {
        margin-right: 8px;
      }
    }

    li {
      width: 30%;
      text-transform: uppercase;
      font-size: 18px;
      padding: 18px 0px 15px 0px;
      border-left: 1px solid #445068;
    }

    li:nth-child(2) {
      border-left: 0px solid #445068;
    }
  }
}


.container-items.alt-layout ul{
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto 1fr;

  div {
    font-size: 14px;
    grid-column: 1 / span 2;
    grid-row: 1 / span 1;
    width: 100%;
    padding: 8px 0px;
    border-bottom: 1px solid #445068;
  }

  li {
    font-size: 15px;
    width: 100%;
    grid-column:  1 / span 1;
    grid-row: 2 / span 1;
  }

  li:last-child {
    width: 100%;
    grid-column:  2 / span 1;
    grid-row: 2 / span 1;
  }

}
</style>